var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuTextAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19.692,
    viewBox: "0 0 15 19.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mainmenu-text-analytics",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M75.606,4.559,71.441.394A1.337,1.337,0,0,0,70.489,0H62.346A1.348,1.348,0,0,0,61,1.346v17a1.348,1.348,0,0,0,1.346,1.346H74.654A1.348,1.348,0,0,0,76,18.346V5.511A1.338,1.338,0,0,0,75.606,4.559Zm-1.575.056H71.577a.193.193,0,0,1-.192-.192V1.97Zm.624,13.923H62.346a.193.193,0,0,1-.192-.192v-17a.193.193,0,0,1,.192-.192h7.885V4.423a1.348,1.348,0,0,0,1.346,1.346h3.269V18.346A.193.193,0,0,1,74.654,18.538Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5903",
    "data-name": "Rectangle 5903",
    width: 9,
    height: 1.8,
    rx: 0.9,
    transform: "translate(63.948 8.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5904",
    "data-name": "Rectangle 5904",
    width: 9,
    height: 1.8,
    rx: 0.9,
    transform: "translate(63.948 12.062)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuTextAnalytics);
export default __webpack_public_path__ + "static/media/Mainmenu-text-analytics.9b8534d9748c73bed1e1a8267a0ed563.svg";
export { ForwardRef as ReactComponent };